import { memo, useCallback } from 'react'

import { AutoDeleteOutlined } from '@mui/icons-material'
import { Divider, ListItemIcon, MenuItem, Typography } from '@mui/material'
import { AudioObject } from '@nativewaves/nw-cloud-sdk/content'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useAudioObjectDeleteMutation } from 'hooks/mutations/content'

const RowActionsRaw = ({ row, onClose, onClick }: RowActionsProps<AudioObject>) => {
  const { t } = useTranslation(['common', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: deleteAudioObject } = useAudioObjectDeleteMutation()

  const handleDeleteAudioObject = useCallback(() => {
    onClose()

    deleteAudioObject(
      { audioId: row.original.id },
      {
        onSuccess: () =>
          enqueueSnackbar(t('domain:Workspace.Audio.nameDelete', { name: row.original.name }), { variant: 'success' }),
        onError: () => {
          enqueueSnackbar(t('somethingWentWrong'), { variant: 'error' })
        },
      },
    )
  }, [deleteAudioObject, enqueueSnackbar, onClose, row.original.id, row.original.name, t])

  const handleLifecycleAudioObject = useCallback(() => {
    onClose()
    onClick?.(row)
  }, [onClick, onClose, row])

  return (
    <>
      <MenuItem onClick={handleLifecycleAudioObject}>
        <ListItemIcon>
          <AutoDeleteOutlined />
        </ListItemIcon>
        <Typography sx={{ width: '100%' }}>{t('domain:Workspace.Audio.setLifecyclePolicy', { count: 1 })}</Typography>
      </MenuItem>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemDelete onConfirm={handleDeleteAudioObject} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
